/** Payment accounts, payments and transfers (docs/specs/payments.md). */
export const payments = {
    accounts: {
        title: "Payment accounts",
        description: "Cash drawers, bank accounts and mobile wallets. Balances come from the payments.",
        empty: "No payment accounts yet.",
        add: "Add account",
        edit: "Edit account",
        name: "Name",
        type: "Type",
        location: "Location",
        register: "Register",
        accountNumber: "Account or wallet number",
        opening: "Opening balance",
        balance: "Balance",
        archive: "Archive",
        archived: "Archived",
        saved: "Account saved.",
        tenantWide: "All locations",
        types: {
            cash_drawer: "Cash drawer",
            cash: "Cash",
            bank: "Bank",
            bkash: "bKash",
            nagad: "Nagad",
            rocket: "Rocket",
            other: "Other",
        },
    },
    list: {
        title: "Payments",
        description: "Money in and out of your accounts. Mistakes are reversed, never edited.",
        empty: "No payments yet.",
        record: "Record payment",
        transfer: "Move money",
        filters: {
            account: "Account",
            method: "Method",
            verification: "Verification",
            reference: "TrxID / reference",
            any: "All",
        },
        columns: {
            number: "Payment",
            date: "Date",
            account: "Account",
            method: "Method",
            reference: "Reference",
            amount: "Amount",
            verification: "Verification",
        },
    },
    direction: { in: "Money in", out: "Money out" },
    methods: {
        cash: "Cash",
        bkash: "bKash",
        nagad: "Nagad",
        rocket: "Rocket",
        bank_transfer: "Bank transfer",
        card: "Card",
        cheque: "Cheque",
        other: "Other",
    },
    verification: {
        not_required: "Not needed",
        pending: "Waiting",
        verified: "Verified",
        failed: "Failed",
    },
    form: {
        title: "Record payment",
        account: "Account",
        direction: "Direction",
        amount: "Amount",
        method: "Method",
        reference: "TrxID / reference",
        note: "Note",
        order: "For order {{number}}",
        save: "Record",
        saved: "Payment {{number}} recorded.",
        duplicate: "This TrxID was already used: {{numbers}}. Check it is not the same payment.",
    },
    actions: {
        reverse: "Reverse",
        reverseReason: "Why is it reversed?",
        reversed: "Payment reversed.",
        verify: "Verified",
        fail: "Failed",
        verifiedDone: "Verification saved.",
    },
    transfer: {
        title: "Move money between accounts",
        from: "From",
        to: "To",
        amount: "Amount",
        note: "Note",
        save: "Move",
        saved: "Transfer {{number}} saved.",
    },
    order: {
        title: "Payments",
        empty: "No payments for this order yet.",
        due: "Still due: {{amount}}",
    },
    linked: {
        account: "Payment account",
        none: "Not from an account",
    },
    reversedBadge: "Reversed",
    reversalOf: "Reversal",
};
//# sourceMappingURL=payments.js.map